/* ============================================================
   IMENHOF BLOOM — mega-menu.js
   Desktop-megamenu: open op klik/hover, takken wisselen via de rail.
   A11y (audit juli 2026):
   • geen role=tab/aria-selected meer — gewone knoppen met aria-current
   • menu opent niet meer op toetsenbord-focus (alleen Enter/klik),
     zodat tabbende gebruikers er niet doorheen gedwongen worden
   • Escape sluit én zet de focus terug op de triggerknop
   ============================================================ */
(function () {
  'use strict';
  function init(scope) {
    var mm = scope.querySelector('[data-mm]'),
        panel = scope.querySelector('[data-mm-panel]');
    if (!mm || !panel || mm.dataset.mmReady) return;
    mm.dataset.mmReady = '1';
    var trigger = mm.querySelector('.mm-trigger'),
        tabs = [].slice.call(panel.querySelectorAll('.mm-tab')),
        panes = [].slice.call(panel.querySelectorAll('.mm-pane')),
        timer;
    function activate(id) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-branch') === id;
        t.classList.toggle('is-active', on);
        if (on) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
      panes.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-branch') === id);
      });
    }
    function open() {
      clearTimeout(timer);
      mm.classList.add('is-open');
      panel.classList.add('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }
    function close() {
      mm.classList.remove('is-open');
      panel.classList.remove('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    }
    function schedule() { timer = setTimeout(close, 150); }
    tabs.forEach(function (t) {
      var go = function () { activate(t.getAttribute('data-branch')); };
      t.addEventListener('mouseenter', go);
      t.addEventListener('focus', go);
      t.addEventListener('click', go);
    });
    if (tabs[0]) activate(tabs[0].getAttribute('data-branch'));
    mm.addEventListener('mouseenter', open);
    mm.addEventListener('mouseleave', schedule);
    panel.addEventListener('mouseenter', function () { clearTimeout(timer); });
    panel.addEventListener('mouseleave', schedule);
    if (trigger) trigger.addEventListener('click', function (e) {
      e.preventDefault();
      if (panel.classList.contains('is-open')) close(); else open();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !panel.classList.contains('is-open')) return;
      close();
      if (trigger) trigger.focus();
    });
    document.addEventListener('click', function (e) {
      if (!mm.contains(e.target) && !panel.contains(e.target)) close();
    });
  }
  function boot() { document.querySelectorAll('[data-mm-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector) init(e.target);
  });
})();
